/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { addNewOperation, updateOperation } from '../../../../../Redux/operations/operationsSlice'
import { useTranslation } from 'react-i18next'

const index = ({ hint, fn, close }) => {
  const { t } = useTranslation() || ((i) => i)
  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.hint_msg}>
        <p className={styles.msg_text}>{t('d_question')}</p>
      </div>
      <div className={styles.btns_container}>
        <button onClick={close} className={styles.cancel_btn}>
          {t('cancel')}
        </button>
        <button onClick={fn} className={styles.confirm_btn}>
          {t('confirm')}
        </button>
      </div>
    </div>
  )
}
export default index
